import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/suppliers/importer`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/supplier/importer')({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/suppliers/importer', search: true, replace: true });
    },
});
